module.exports = __webpack_public_path__ + "static/media/location_los_angeles.9142b0e3.jpg";